export default __webpack_public_path__ + "static/media/banner-resources.9854248f.webp";